import { usePrefsStore } from '../store/prefsStore'
import { PALETTE_KEYS, PALETTE_LABELS, resolvePalette, samplePalette } from '../utils/palettes'
import { CLASS_METHODS } from '../utils/classify'
import { DEFAULT_PREFS } from '../store/prefsStore'
import '../styles/RampEditor.css'

// Ramp editor (S11): choose the choropleth palette, classification method and
// class count for the continuous layers (population / density / GDP). Reset
// restores defaults. Values persist via prefsStore and drive useMapLayers.
export default function RampEditor() {
  const palette = usePrefsStore((s) => s.palette)
  const classification = usePrefsStore((s) => s.classification)
  const nClasses = usePrefsStore((s) => s.nClasses)
  const customRamp = usePrefsStore((s) => s.customRamp)
  const setPref = usePrefsStore((s) => s.setPref)
  const setPrefs = usePrefsStore((s) => s.setPrefs)

  const swatches = samplePalette(resolvePalette(palette, customRamp), nClasses)

  const reset = () => setPrefs({
    palette: DEFAULT_PREFS.palette,
    classification: DEFAULT_PREFS.classification,
    nClasses: DEFAULT_PREFS.nClasses,
    customRamp: DEFAULT_PREFS.customRamp,
  })

  return (
    <div className="ramp-editor">
      <div className="filter-group">
        <label>Palette</label>
        <select className="main-select" value={palette} onChange={(e) => setPref('palette', e.target.value)}>
          {PALETTE_KEYS.map((k) => (
            <option key={k} value={k}>{PALETTE_LABELS[k] || k}</option>
          ))}
          <option value="custom">custom</option>
        </select>
      </div>

      <div className="ramp-preview">
        {swatches.map((c, i) => (
          <span
            key={i}
            className="ramp-swatch"
            style={{ background: c }}
            title={palette === 'custom' ? 'Cliquer pour éditer' : c}
            onClick={() => {
              if (palette !== 'custom') return
              const next = [...(customRamp || swatches)]
              const picked = window.prompt('Couleur (hex) :', next[i] || c)
              if (picked && /^#[0-9a-f]{6}$/i.test(picked)) { next[i] = picked; setPref('customRamp', next) }
            }}
          />
        ))}
      </div>
      {palette === 'custom' && !customRamp && (
        <button type="button" className="ramp-seed" onClick={() => setPref('customRamp', swatches)}>
          Initialiser la palette personnalisée
        </button>
      )}

      <div className="filter-group">
        <label>Classification</label>
        <select className="main-select" value={classification} onChange={(e) => setPref('classification', e.target.value)}>
          {CLASS_METHODS.map((m) => (
            <option key={m.key} value={m.key}>{m.label}</option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label>Classes : {nClasses}</label>
        <input
          type="range" min="3" max="9" step="1"
          value={nClasses}
          onChange={(e) => setPref('nClasses', parseInt(e.target.value, 10))}
        />
      </div>

      <button type="button" className="ramp-reset" onClick={reset}>Réinitialiser</button>
      <p className="section-hint">S'applique aux couches Population, Densité et PIB/hab.</p>
    </div>
  )
}
